import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row} from 'react-bootstrap';
import './Resetfilter.css';


const Resetfilter = observer(
  class Resetfilter extends Component {
	
		state = {baba:'dudu'};
		
		resetFilter = (ev) => {
			document.getElementById('mainsearchinput').value = '';
			this.props.setcritcb({offset:0,weeks:[],chains:[],statis:[],genres:[],fulltext:''});
		}
			
    render() {
			return  (
					<div className="resetfilter" onClick={this.resetFilter}>
						Réinitialiser les filtres
					</div>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Resetfilter);